var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBuildingsAreaFacade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.656 194.994C7.29245 194.813 3 190.408 3 185V164.853L125.124 42.7073L145.138 62.4878L12.656 194.994ZM92.2334 195H52.4418L165.153 82.2684L172.029 89.0642C173.93 90.9428 175 93.5042 175 96.1768V112.218L92.2334 195ZM175 152.017V185C175 190.523 170.523 195 165 195H132.025L175 152.017ZM105.109 22.9267L3 125.054V96.2109C3 93.5182 4.08594 90.9393 6.01211 89.0577L82.4714 14.3662C86.373 10.5548 92.6092 10.573 96.4886 14.407L105.109 22.9267Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 95.4895V185C3 190.523 7.47716 195 13 195H88.8838H164.768C170.291 195 174.768 190.523 174.768 185V95.4895C174.768 92.8469 173.722 90.3119 171.858 88.4381L95.9746 12.1303C92.0649 8.19881 85.7028 8.19881 81.7931 12.1304L5.90926 88.4381C4.04594 90.3119 3 92.8469 3 95.4895Z",
    stroke: "black",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBuildingsAreaFacade);
export default __webpack_public_path__ + "static/media/ico_buildings_area_facade.5abb6b671e4e29d36c6ed47440d8386f.svg";
export { ForwardRef as ReactComponent };